export const SOUNDS = [
  {asset: require('@/assets/notificationSounds/echoed-ding.mp3'), name:'Echoed Ding'},
  {asset: require('@/assets/notificationSounds/expect-good-news.mp3'),name:'Expect Good News'},
  {asset: require('@/assets/notificationSounds/slow_spring_board.mp3'),name:'Slow Spring Board'},
  {asset: require('@/assets/notificationSounds/solemn.mp3'),name:'Solemn'},
  {asset: require('@/assets/notificationSounds/swiftly.mp3'),name:'Swiftly'}
];
